const METRIKA_COUNTER_ID = 110538772;
const runtimeConfig = (typeof window !== "undefined" && window.APP_CONFIG) || {};
const API_BASE = runtimeConfig.API_BASE || "https://tarovarvara.ru";

const CLICK_TOKEN_KEY = "tv_click_token";
const CLIENT_ID_KEY = "tv_ym_client_id";

function reachGoal(goal) {
  if (typeof window === "undefined" || typeof window.ym !== "function") return;
  window.ym(METRIKA_COUNTER_ID, "reachGoal", goal);
}

// Один clickToken на посетителя, переживает несколько визитов (localStorage), а не одну сессию —
// подставляется в start= ссылки на бота (см. site.js:buildBotLink), бэкенд по нему находит визит с yclid/UTM.
export function getOrCreateClickToken() {
  if (typeof window === "undefined") return "";
  try {
    const existing = window.localStorage.getItem(CLICK_TOKEN_KEY);
    if (existing) return existing;
    const random = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const token = random.replace(/[^a-z0-9]/gi, "").slice(0, 24);
    window.localStorage.setItem(CLICK_TOKEN_KEY, token);
    return token;
  } catch {
    return "";
  }
}

function cacheClientId(id) {
  try {
    window.localStorage.setItem(CLIENT_ID_KEY, id);
  } catch {
    // localStorage недоступен (приватный режим и т.п.) — просто не кешируем
  }
}

function getCachedClientId() {
  try {
    return window.localStorage.getItem(CLIENT_ID_KEY) || "";
  } catch {
    return "";
  }
}

// ym('getClientID') асинхронный колбэк — ждём его коротко, иначе не блокируем отправку визита.
function getClientId(timeoutMs = 300) {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || typeof window.ym !== "function") {
      resolve(getCachedClientId());
      return;
    }
    let done = false;
    const finish = (id) => {
      if (done) return;
      done = true;
      resolve(id || getCachedClientId());
    };
    try {
      window.ym(METRIKA_COUNTER_ID, "getClientID", (id) => {
        if (id) cacheClientId(id);
        finish(id);
      });
    } catch {
      finish("");
    }
    setTimeout(() => finish(getCachedClientId()), timeoutMs);
  });
}

const TRACKED_QUERY_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "yclid",
  "source",
  "source_type",
  "position_type",
  "ad_id",
  "gbid",
  "device_type",
  "region_id",
];

function safeValue(value, max = 220) {
  return String(value || "").trim().slice(0, max);
}

function landingPayload(extra = {}) {
  if (typeof window === "undefined") return extra;

  const params = new URLSearchParams(window.location.search);
  const query = {};
  for (const key of TRACKED_QUERY_KEYS) {
    const value = params.get(key);
    if (value) query[key] = safeValue(value);
  }

  let referrerHost = "";
  try {
    referrerHost = document.referrer ? new URL(document.referrer).host : "";
  } catch {
    referrerHost = "";
  }

  return {
    ...query,
    ...extra,
    clickToken: getOrCreateClickToken(),
    path: safeValue(window.location.pathname, 120),
    referrerHost: safeValue(referrerHost, 120),
    userAgent: safeValue(navigator.userAgent, 260),
  };
}

function sendEvent(path, payload) {
  const url = `${API_BASE}${path}`;
  const body = JSON.stringify(payload);
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }));
  } else {
    fetch(url, { method: "POST", body, keepalive: true }).catch(() => {});
  }
}

export async function trackVisit() {
  reachGoal("landing_visit");
  const clientId = await getClientId();
  sendEvent("/webhooks/landing-visit", landingPayload({ clientId }));
}

export function trackClick(target) {
  reachGoal(`landing_click_${target}`);
  sendEvent("/webhooks/landing-click", landingPayload({ target, clientId: getCachedClientId() }));
}
